import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { Section, Eyebrow } from "./primitives";
import { PRESALE_CONFIG, DOC_CONFIG } from "@/config/site";
import CountdownTimer from "./CountdownTimer";

export default function PresaleSection() {
  const c = PRESALE_CONFIG;

  return (
    <Section id="presale">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal className="flex flex-col gap-6 lg:sticky lg:top-28">
            <Eyebrow>Conversion</Eyebrow>
            <h2 className="font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl">
              XVPR<br />Presale
            </h2>
            <p className="max-w-md text-base leading-relaxed text-gray-400 sm:text-lg">
              Get ready ahead of the public launch. The presale opens November 1, 2026. All presale
              figures are managed from a single configuration and update instantly once supplied.
            </p>
            <div className="flex items-center gap-3 rounded-xl border border-emerald-400/20 bg-emerald-400/5 px-4 py-3">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-70" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
              </span>
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-emerald-200">
                Presale Opens Nov 1, 2026
              </span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal
            delay={0.1}
            className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] p-6 shadow-2xl shadow-indigo-900/20 backdrop-blur-xl sm:p-8"
            data-testid="presale-card"
          >
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-indigo-600/20 blur-[90px]" />

            <div className="relative flex items-center justify-between">
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-gray-500">XVPR Presale</span>
              <div className="rounded-full border border-indigo-400/30 bg-indigo-500/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-indigo-200">
                Upcoming
              </div>
            </div>

            {/* Countdown to presale start */}
            {c.presaleStart && (
              <CountdownTimer target={c.presaleStart} className="relative mt-6" />
            )}

            <a
              href={DOC_CONFIG.whitepaperUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative mt-7 flex w-full items-center justify-center gap-2 rounded-full border border-white/20 py-4 font-mono text-sm font-bold uppercase tracking-[0.16em] text-white transition-all hover:border-white/50 hover:bg-white/5"
              data-testid="presale-whitepaper-button"
            >
              Read Whitepaper
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <p className="relative mt-3 text-center font-mono text-[10px] uppercase tracking-[0.16em] text-gray-600">
              Presale participation opens November 1, 2026
            </p>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
